<template>
  <div class="page">
    <div class="input-bar">
      <el-input v-model="keywords" class="search" placeholder="请输入商户名称/商户号/商户登录号/分账渠道">
        <el-button slot="append" type="primary">搜索</el-button>
      </el-input>
    </div>
    <div class="infoes">
      <div class="top">合计：9条</div>
      <div class="bottom">
        <div><span>已启用：</span><span>9条</span></div>
        <div><span>未启用：</span><span>9条</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RQuery',
  data() {
    return {
      keywords: '',
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  display: flex;
  align-items: center;
  background-color: #fff;
  margin-top: 10px;
  padding: 20px;
  border-radius: 5px;
  .input-bar {
    .search {
      width: 400px;
    }
  }
  .infoes {
    margin-left: 222px;
    .top {
      color: #333;
      font-size: 16px;
      line-height: 22px;
    }
    .bottom {
      margin-top: 5px;
      font-size: 14px;
      div {
        display: inline-flex;
        margin-right: 40px;
        color: #666;
        line-height: 20px;
        span:last-child {
          color: #333;
        }
      }
    }
  }
}
.el-input-group__append button.el-button {
  .button--primary(@primary-blue);
  color: @bg-white;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 40px;
}
</style>
